import { DRIVER_PAGE_OBJECT } from "../../../pages/drivers/driverPageConf";
import { loadStatusColorGenerator, loadStatusFormatter } from "../../../pages/loads/loadDataDelegate";
import { LOAD_PAGE_OBJECT } from "../../../pages/loads/loadPageConf";
import { PayableInvoicesManagement } from "../../../pages/reports/payableInvoicesManagement";
import { TRAILER_PAGE_OBJECT } from "../../../pages/trailers/trailerPageConf";
import { TRUCK_PAGE_OBJECT } from "../../../pages/trucks/truckPageConf";
import { retrieveCompanyData } from "../../../supplementary_components/companySettings";
import { addPopup } from "../../../supplementary_components/store";
import { ItemPage } from "../item_page/itemPage";
import { NestedValueExtractor } from "../list_view/listView";
import styles from './itemOnPopup.module.scss';


export const PopupOnClick = ({ text, itemType, itemId, companyData, alwaysUnderlined = false }) => {
    return <div><span
        className={alwaysUnderlined ? `${styles.clickableItem} ${styles.clickableItemUnderlined}` : styles.clickableItem}
        onClick={()=>{
            addPopup({
                content:ItemOnPopup,
                popupData: {
                    itemType: itemType,
                    itemId: itemId,
                    companyData,
                },
                customWidth: "90%",
                customMaxWidth: "1700px",
                customMinWidth: "880px",
                EZCloseAllowed:true
            })
        }}>{text}</span></div>
}

export const ItemOnPopup = ({closePopup, popupData}) => {
    const category = popupData.itemType;

    if (category === 'payableInvoice') {
        const companyData = popupData.companyData ?? retrieveCompanyData();
        return (
            <div className={styles.itemOnPopup} onClick={(e) => e.stopPropagation()}>
                <PayableInvoicesManagement
                    companyData={companyData}
                    elementIdentifier={
                        popupData.itemId != null ? String(popupData.itemId) : null
                    }
                />
            </div>
        );
    }

    const itemConf = {
        pageConf : category === "load" ? new LOAD_PAGE_OBJECT(NestedValueExtractor, loadStatusFormatter, loadStatusColorGenerator) : 
        category === "truck" ? new TRUCK_PAGE_OBJECT()  :
        category === 'trailer'? new TRAILER_PAGE_OBJECT() :
        category === "driver" ? new DRIVER_PAGE_OBJECT() :
        null,
    }
    return <div className={styles.itemOnPopup}  onClick={e=>e.stopPropagation()} >
        <ItemPage conf={itemConf} identifier={popupData.itemId} />
    </div>
}
//$customWidth={"90%"} $customMaxWidth={"1400px"} $customMinWidth={"1400px"}>